<template>
  <div class="office-checkin-container">
    <!-- 南北区同行容器：Element栅格布局，等分且响应式 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <!-- 北区统计模块：大屏等分，小屏整行 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-card class="table-card" shadow="never">
          <div class="table-header">
            <div class="table-title">
              <i class="el-icon-data-analysis"></i>
              北区 - 楼栋租赁统计
            </div>
          </div>
          
          <el-table
            v-loading="loading"
            :data="northData"
            border
            stripe
            style="width: 100%"
            :height="tableHeight"
          >
            <el-table-column label="序号" width="70" align="center">
              <template slot-scope="scope">
                <span class="serial-number">{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="building" label="楼栋" width="120" align="center" show-overflow-tooltip />
            <el-table-column prop="forRent" label="建筑面积(㎡)" width="130" align="center">
              <template slot-scope="{ row }">{{ formatNumber(row.forRent, 1) }}</template>
            </el-table-column>
            <el-table-column prop="rentedArea" label="已租面积(㎡)" width="130" align="center">
              <template slot-scope="{ row }">{{ formatNumber(row.rentedArea, 1) }}</template>
            </el-table-column>
            <el-table-column prop="vacantArea" label="空置面积(㎡)" width="130" align="center">
              <template slot-scope="{ row }">{{ formatNumber(row.vacantArea, 1) }}</template>
            </el-table-column>
            <el-table-column prop="rentedPercent" label="出租率" width="120" align="center">
              <template slot-scope="{ row }">{{ formatPercent(row.rentedPercent, 2) }}</template>
            </el-table-column>
            <el-table-column prop="vacantPercent" label="空置率" width="120" align="center">
              <template slot-scope="{ row }">{{ formatPercent(row.vacantPercent, 2) }}</template>
            </el-table-column>
          </el-table>

          <!-- 北区底部统计行 -->
          <div class="area-total" style="margin-top: 10px; text-align: right; font-weight: 600; color: #303133;">
            北区合计：可租面积 {{ formatNumber(northTotal.forRent, 1) }} ㎡，已租面积 {{ formatNumber(northTotal.rentedArea, 1) }} ㎡，空置面积 {{ formatNumber(northTotal.vacantArea, 1) }} ㎡，
            平均出租率 {{ formatPercent(northTotal.rentedPercent, 2) }}，平均空置率 {{ formatPercent(northTotal.vacantPercent, 2) }}
          </div>
        </el-card>
      </el-col>

      <!-- 南区统计模块：与北区同规则 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-card class="table-card" shadow="never">
          <div class="table-header">
            <div class="table-title">
              <i class="el-icon-data-analysis"></i>
              南区 - 楼栋租赁统计
            </div>
          </div>
          
          <el-table
            v-loading="loading"
            :data="southData"
            border
            stripe
            style="width: 100%"
            :height="tableHeight"
          >
            <el-table-column label="序号" width="70" align="center">
              <template slot-scope="scope">
                <span class="serial-number">{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="building" label="楼栋" width="120" align="center" show-overflow-tooltip />
            <el-table-column prop="forRent" label="建筑面积(㎡)" width="130" align="center">
              <template slot-scope="{ row }">{{ formatNumber(row.forRent, 1) }}</template>
            </el-table-column>
            <el-table-column prop="rentedArea" label="已租面积(㎡)" width="130" align="center">
              <template slot-scope="{ row }">{{ formatNumber(row.rentedArea, 1) }}</template>
            </el-table-column>
            <el-table-column prop="vacantArea" label="空置面积(㎡)" width="130" align="center">
              <template slot-scope="{ row }">{{ formatNumber(row.vacantArea, 1) }}</template>
            </el-table-column>
            <el-table-column prop="rentedPercent" label="出租率" width="120" align="center">
              <template slot-scope="{ row }">{{ formatPercent(row.rentedPercent, 2) }}</template>
            </el-table-column>
            <el-table-column prop="vacantPercent" label="空置率" width="120" align="center">
              <template slot-scope="{ row }">{{ formatPercent(row.vacantPercent, 2) }}</template>
            </el-table-column>
          </el-table>

          <!-- 南区底部统计行 -->
          <div class="area-total" style="margin-top: 10px; text-align: right; font-weight: 600; color: #303133;">
            南区合计：可租面积 {{ formatNumber(southTotal.forRent, 1) }} ㎡，已租面积 {{ formatNumber(southTotal.rentedArea, 1) }} ㎡，空置面积 {{ formatNumber(southTotal.vacantArea, 1) }} ㎡，
            平均出租率 {{ formatPercent(southTotal.rentedPercent, 2) }}，平均空置率 {{ formatPercent(southTotal.vacantPercent, 2) }}
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 仅文字展示南北区合并统计（核心改造：移除原合并表格，保留高亮文字总计） -->
    <div class="total-all" style="font-weight: bold; font-size: 16px; color: #e6a23c; padding: 15px; background-color: #fdf6ec; border-radius: 8px; border: 1px solid #fde2cf;">
      📊 南北区合并统计：可租面积 {{ formatNumber(totalAll.forRent, 1) }} ㎡，已租面积 {{ formatNumber(totalAll.rentedArea, 1) }} ㎡，空置面积 {{ formatNumber(totalAll.vacantArea, 1) }} ㎡，
      整体平均出租率 {{ formatPercent(totalAll.rentedPercent, 2) }}，整体平均空置率 {{ formatPercent(totalAll.vacantPercent, 2) }}
    </div>
  </div>
</template>

<script>
// 引入统计接口API（无修改）
import rentStatApi from '../api/rentStat.js'

export default {
  name: "RentStatList",
  components: {},
  data() {
    return {
      loading: false,
      originalData: [],
      northData: [],
      southData: [],
      tableHeight: 400, // 表格固定高度，适配同行布局
      northTotal: {},
      southTotal: {},
      totalAll: {}
    }
  },
  created() {
    this.getHousingStatistics();
  },
  methods: {
    // 获取数据（无修改）
    getHousingStatistics() {
      const self = this;
      this.loading = true;
      rentStatApi.getHousingStatistics().then(function(response) {
        if (response && response.data && response.data.flag === true) {
          self.originalData = response.data.data || [];
          self.splitAreaData();
          self.calcNorthTotal();
          self.calcSouthTotal();
          self.calcTotalAll();
          console.log('数据加载完成，北区：' + self.northData.length + '条，南区：' + self.southData.length + '条');
        } else {
          self.$message.error('获取租赁统计数据失败');
          self.originalData = [];
          self.northData = [];
          self.southData = [];
        }
      }).catch(function(error) {
        console.error('获取租赁统计数据失败:', error);
        self.$message.error('加载失败，请检查网络连接');
        self.originalData = [];
        self.northData = [];
        self.southData = [];
      }).finally(function() {
        self.loading = false;
      });
    },
    // 拆分南北区数据（无修改）
    splitAreaData() {
      this.northData = this.originalData.filter(item => item.address === '北区');
      this.southData = this.originalData.filter(item => item.address === '南区');
    },
    // 北区统计（无修改）
    calcNorthTotal() {
      this.northTotal = this.calcAreaTotal(this.northData);
    },
    // 南区统计（无修改）
    calcSouthTotal() {
      this.southTotal = this.calcAreaTotal(this.southData);
    },
    // 整体合并统计（无修改，数据逻辑保留）
    calcTotalAll() {
      this.totalAll = this.calcAreaTotal(this.originalData);
    },
    // 通用统计方法（无修改）
    calcAreaTotal(data) {
      if (!data || data.length === 0) {
        return { forRent: 0, rentedArea: 0, vacantArea: 0, rentedPercent: 0, vacantPercent: 0 };
      }
      const forRent = data.reduce((sum, item) => sum + Number(item.forRent || 0), 0);
      const rentedArea = data.reduce((sum, item) => sum + Number(item.rentedArea || 0), 0);
      const vacantArea = data.reduce((sum, item) => sum + Number(item.vacantArea || 0), 0);
      const rentedPercent = data.reduce((sum, item) => sum + Number(item.rentedPercent || 0), 0) / data.length;
      const vacantPercent = data.reduce((sum, item) => sum + Number(item.vacantPercent || 0), 0) / data.length;
      return { forRent, rentedArea, vacantArea, rentedPercent, vacantPercent };
    },
    // 数字格式化（无修改）
    formatNumber(num, decimal = 0) {
      if (!num && num !== 0) return '0.0';
      return Number(num).toFixed(decimal);
    },
    // 百分比格式化（无修改）
    formatPercent(percent, decimal = 2) {
      if (!percent && percent !== 0) return '0.00%';
      return (Number(percent) * 100).toFixed(decimal) + '%';
    }
  }
}
</script>

<style scoped>
.office-checkin-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(90vh - 84px);
}

.table-card {
  border-radius: 8px;
  overflow: hidden;
  border: none;
  height: 100%; /* 关键：卡片高度自适应，同行对齐 */
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 8px;
}

.table-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}

.table-title i {
  margin-right: 8px;
  color: #409EFF;
  font-size: 20px;
}

.serial-number {
  color: #909399;
  font-weight: 500;
}

/* 表格样式（无修改） */
.el-table {
  font-size: 14px;
}
.el-table th {
  background-color: #f5f7fa !important;
  font-weight: 600;
}
.el-table td {
  padding: 12px 0;
}

/* 区域合计样式（无修改） */
.area-total {
  font-size: 14px;
  line-height: 1.8;
}

/* 栅格布局适配（无修改） */
:deep(.el-row) {
  width: 100%;
}
:deep(.el-col) {
  height: 100%;
}
</style>